import React from 'react';
import { useCustomComponent } from '@/hooks';

const DotsComponent: React.FC = () => {
  return (
    <div className="peptalk-typing-indicator-content">
      <div className="peptalk-typing-dots">
        <span className="peptalk-typing-dot"></span>
        <span className="peptalk-typing-dot"></span>
        <span className="peptalk-typing-dot"></span>
      </div>
    </div>
  );
};

export const Dots: React.FC = () => {
  const Component = useCustomComponent({
    componentName: 'TypingIndicatorDots',
    Component: DotsComponent,
  });

  return <Component />;
};
